import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'gatsby';
import { Offcanvas } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../../state/Store';
import {
  ToggleGameSwitcher,
  ToggleMenu,
  SetGameHover
} from '../actions/Layout.actions';
import { Logo } from '../../common/components/logo';
import { CSMenu } from '../../cs/common/components/cs-menu';
import { LCMenu } from '../../lc/common/components/lc-menu';
import { NIKKEMenu } from '../../nikke/common/components/nikke-menu';
import { EversoulMenu } from '../../es/common/components/eversoul-menu';
import { HSRMenu } from '../../hsr/common/components/hsr-menu';
import { TOGMenu } from '../../tog/common/components/tog-menu';
import { REVMenu } from '../../reverse/common/components/rev-menu';
import { faWindowRestore } from '@fortawesome/free-regular-svg-icons';
import { ZZZMenu } from '../../zzz/common/components/zzz-menu';
import { AFKMenu } from '../../afk/common/components/afk-menu';
import { EndfieldMenu } from '../../endfield/components/endfield-menu';
import { ExiliumMenu } from '../../exilium/components/exilium-menu';
import { WWMenu } from '../../ww/common/components/ww-menu';
import { SoloMenu } from '../../solo/common/components/solo-menu';
import { AshMenu } from '../../ash/components/ash-menu';
import { EtheriaMenu } from '../../etheria/components/eth-menu';

interface IProps {
  game: string;
}

export const DashboardNavbar: React.FC<IProps> = (props) => {
  const model = useSelector((state: RootState) => ({
    layout: state.layout
  }));

  const dispatch = useDispatch();

  return (
    <>
      <Offcanvas
        show={model.layout.isMenuVisible}
        onHide={() => dispatch(ToggleMenu())}
        className="offcanvas-menu"
        scroll={true}
      >
        <Offcanvas.Header closeButton closeVariant="white">
          <Offcanvas.Title>
            <Logo size="full" />
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          {props.game === 'cs' && <CSMenu />}
          {props.game === 'nikke' && <NIKKEMenu />}
          {props.game === 'lc' && <LCMenu />}
          {props.game === 'es' && <EversoulMenu />}
          {props.game === 'hsr' && <HSRMenu />}
          {props.game === 'tog' && <TOGMenu />}
          {props.game === 'reverse' && <REVMenu />}
          {props.game === 'zzz' && <ZZZMenu />}
          {props.game === 'afk' && <AFKMenu />}
          {props.game === 'endfield' && <EndfieldMenu />}
          {props.game === 'exilium' && <ExiliumMenu />}
          {props.game === 'ww' && <WWMenu />}
          {props.game === 'solo' && <SoloMenu />}
          {props.game === 'ash' && <AshMenu />}
          {props.game === 'etheria' && <EtheriaMenu />}
        </Offcanvas.Body>
      </Offcanvas>
      <Offcanvas
        show={model.layout.isGameSwitcherVisible}
        onHide={() => dispatch(ToggleGameSwitcher())}
        className={`offcanvas-game-switcher ${model.layout.gameSwitcherHover}`}
        scroll={true}
      >
        <Offcanvas.Header closeButton closeVariant="white">
          <Offcanvas.Title>
            <Logo size="full" />
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <p>Quickly switch to another game.</p>
          <div className="game-box-container">
            <Link
              to="/afk-journey/"
              className="game-box-small afk"
              onMouseOver={() => dispatch(SetGameHover('afk'))}
              onClick={() => dispatch(ToggleGameSwitcher())}
            >
              <p>AFK Journey</p>
            </Link>
            <Link
              to="/arknights-endfield/"
              className="game-box-small endfield"
              onMouseOver={() => dispatch(SetGameHover('endfield'))}
              onClick={() => dispatch(ToggleGameSwitcher())}
            >
              <p>Arknights: Endfield</p>
            </Link>
            <Link
              to="/ash-echoes/"
              className="game-box-small ash"
              onMouseOver={() => dispatch(SetGameHover('ash'))}
              onClick={() => dispatch(ToggleGameSwitcher())}
            >
              <p>Ash Echoes Global</p>
            </Link>
            <Link
              to="/counter-side/"
              className="game-box-small cs"
              onMouseOver={() => dispatch(SetGameHover('cs'))}
              onClick={() => dispatch(ToggleGameSwitcher())}
            >
              <p>Counter Side</p>
            </Link>
            <Link
              to="/etheria-restart/"
              className="game-box-small eth"
              onMouseOver={() => dispatch(SetGameHover('etheria'))}
              onClick={() => dispatch(ToggleGameSwitcher())}
            >
              <p>Etheria: Restart</p>
            </Link>
            <Link
              to="/eversoul/"
              className="game-box-small es"
              onMouseOver={() => dispatch(SetGameHover('es'))}
              onClick={() => dispatch(ToggleGameSwitcher())}
            >
              <p>Eversoul</p>
            </Link>
            <Link
              to="/gfl-exilium/"
              className="game-box-small exilium"
              onMouseOver={() => dispatch(SetGameHover('exilium'))}
              onClick={() => dispatch(ToggleGameSwitcher())}
            >
              <p>GFL 2: Exilium</p>
            </Link>
            <Link
              to="/star-rail/"
              className="game-box-small hsr"
              onMouseOver={() => dispatch(SetGameHover('hsr'))}
              onClick={() => dispatch(ToggleGameSwitcher())}
            >
              <p>Honkai: Star Rail</p>
            </Link>
            <Link
              to="/limbus-company/"
              className="game-box-small lc"
              onMouseOver={() => dispatch(SetGameHover('lc'))}
              onClick={() => dispatch(ToggleGameSwitcher())}
            >
              <p>Limbus Company</p>
            </Link>
            <Link
              to="/nikke/"
              className="game-box-small nikke"
              onMouseOver={() => dispatch(SetGameHover('nikke'))}
              onClick={() => dispatch(ToggleGameSwitcher())}
            >
              <p>NIKKE</p>
            </Link>
            <Link
              to="/re1999/"
              className="game-box-small reverse"
              onMouseOver={() => dispatch(SetGameHover('reverse'))}
              onClick={() => dispatch(ToggleGameSwitcher())}
            >
              <p>Reverse: 1999</p>
            </Link>
            <Link
              to="/solo-leveling/"
              className="game-box-small solo"
              onMouseOver={() => dispatch(SetGameHover('solo'))}
              onClick={() => dispatch(ToggleGameSwitcher())}
            >
              <p>Solo Leveling: Arise</p>
            </Link>
            <Link
              to="/wuthering-waves/"
              className="game-box-small ww"
              onMouseOver={() => dispatch(SetGameHover('ww'))}
              onClick={() => dispatch(ToggleGameSwitcher())}
            >
              <p>Wuthering Waves</p>
            </Link>
            <Link
              to="/zenless/"
              className="game-box-small zzz"
              onMouseOver={() => dispatch(SetGameHover('zzz'))}
              onClick={() => dispatch(ToggleGameSwitcher())}
            >
              <p>Zenless Zone Zero</p>
            </Link>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
      <div className="left-menu">
        <div className="logo">
          <Logo size="full" />
          <Logo size="minimal" />
        </div>
        <div className="left-menu-content-wrapper">
          <div className="left-menu-content">
            {props.game === 'cs' && (
              <>
                <div
                  className="game-switcher cs"
                  onClick={() => dispatch(ToggleGameSwitcher())}
                >
                  <span className="game-name">Counter Side</span>
                  <span className="icon">
                    <FontAwesomeIcon icon={faWindowRestore} width="18" />
                  </span>
                </div>
                <CSMenu />
              </>
            )}
            {props.game === 'afk' && (
              <>
                <div
                  className="game-switcher afk"
                  onClick={() => dispatch(ToggleGameSwitcher())}
                >
                  <span className="game-name">AFK Journey</span>
                  <span className="icon">
                    <FontAwesomeIcon icon={faWindowRestore} width="18" />
                  </span>
                </div>
                <AFKMenu />
              </>
            )}
            {props.game === 'etheria' && (
              <>
                <div
                  className="game-switcher eth"
                  onClick={() => dispatch(ToggleGameSwitcher())}
                >
                  <span className="game-name">Etheria: Restart</span>
                  <span className="icon">
                    <FontAwesomeIcon icon={faWindowRestore} width="18" />
                  </span>
                </div>
                <EtheriaMenu />
              </>
            )}
            {props.game === 'endfield' && (
              <>
                <div
                  className="game-switcher endfield"
                  onClick={() => dispatch(ToggleGameSwitcher())}
                >
                  <span className="game-name">Arknights: Endfield</span>
                  <span className="icon">
                    <FontAwesomeIcon icon={faWindowRestore} width="18" />
                  </span>
                </div>
                <EndfieldMenu />
              </>
            )}
            {props.game === 'exilium' && (
              <>
                <div
                  className="game-switcher exilium"
                  onClick={() => dispatch(ToggleGameSwitcher())}
                >
                  <span className="game-name">GFL 2: Exilium</span>
                  <span className="icon">
                    <FontAwesomeIcon icon={faWindowRestore} width="18" />
                  </span>
                </div>
                <ExiliumMenu />
              </>
            )}
            {props.game === 'nikke' && (
              <>
                <div
                  className="game-switcher nikke"
                  onClick={() => dispatch(ToggleGameSwitcher())}
                >
                  <span className="game-name">NIKKE</span>
                  <span className="icon">
                    <FontAwesomeIcon icon={faWindowRestore} width="18" />
                  </span>
                </div>
                <NIKKEMenu />
              </>
            )}
            {props.game === 'lc' && (
              <>
                <div
                  className="game-switcher lc"
                  onClick={() => dispatch(ToggleGameSwitcher())}
                >
                  <span className="game-name">Limbus Company</span>
                  <span className="icon">
                    <FontAwesomeIcon icon={faWindowRestore} width="18" />
                  </span>
                </div>
                <LCMenu />
              </>
            )}
            {props.game === 'es' && (
              <>
                <div
                  className="game-switcher es"
                  onClick={() => dispatch(ToggleGameSwitcher())}
                >
                  <span className="game-name">Eversoul</span>
                  <span className="icon">
                    <FontAwesomeIcon icon={faWindowRestore} width="18" />
                  </span>
                </div>
                <EversoulMenu />
              </>
            )}
            {props.game === 'hsr' && (
              <>
                <div
                  className="game-switcher hsr"
                  onClick={() => dispatch(ToggleGameSwitcher())}
                >
                  <span className="game-name">Honkai: Star Rail</span>
                  <span className="icon">
                    <FontAwesomeIcon icon={faWindowRestore} width="18" />
                  </span>
                </div>
                <HSRMenu />
              </>
            )}
            {props.game === 'reverse' && (
              <>
                <div
                  className="game-switcher reverse"
                  onClick={() => dispatch(ToggleGameSwitcher())}
                >
                  <span className="game-name">Reverse: 1999</span>
                  <span className="icon">
                    <FontAwesomeIcon icon={faWindowRestore} width="18" />
                  </span>
                </div>
                <REVMenu />
              </>
            )}
            {props.game === 'zzz' && (
              <>
                <div
                  className="game-switcher zzz"
                  onClick={() => dispatch(ToggleGameSwitcher())}
                >
                  <span className="game-name">Zenless Zone Zero</span>
                  <span className="icon">
                    <FontAwesomeIcon icon={faWindowRestore} width="18" />
                  </span>
                </div>
                <ZZZMenu />
              </>
            )}
            {props.game === 'solo' && (
              <>
                <div
                  className="game-switcher solo"
                  onClick={() => dispatch(ToggleGameSwitcher())}
                >
                  <span className="game-name">Solo Leveling: Arise</span>
                  <span className="icon">
                    <FontAwesomeIcon icon={faWindowRestore} width="18" />
                  </span>
                </div>
                <SoloMenu />
              </>
            )}
            {props.game === 'tog' && (
              <>
                <div
                  className="game-switcher tog"
                  onClick={() => dispatch(ToggleGameSwitcher())}
                >
                  <span className="game-name">Tower of God</span>
                  <span className="icon">
                    <FontAwesomeIcon icon={faWindowRestore} width="18" />
                  </span>
                </div>
                <TOGMenu />
              </>
            )}
            {props.game === 'ww' && (
              <>
                <div
                  className="game-switcher ww"
                  onClick={() => dispatch(ToggleGameSwitcher())}
                >
                  <span className="game-name">Wuthering Waves</span>
                  <span className="icon">
                    <FontAwesomeIcon icon={faWindowRestore} width="18" />
                  </span>
                </div>
                <WWMenu />
              </>
            )}
            {props.game === 'ash' && (
              <>
                <div
                  className="game-switcher ash"
                  onClick={() => dispatch(ToggleGameSwitcher())}
                >
                  <span className="game-name">Ash Echoes Global</span>
                  <span className="icon">
                    <FontAwesomeIcon icon={faWindowRestore} width="18" />
                  </span>
                </div>
                <AshMenu />
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
